import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material';
import { Slider as MUISlider } from '@mui/material';
const Slider = styled(MUISlider)({
    height: 9,
    margin: '10px 20px',
    width: '94%',
    '& .MuiSlider-track': {
        background: 'none',
        border: 'none',
    },
    '& .MuiSlider-rail': {
        height: 9,
        borderRadius: '36px',
        opacity: 1,
        background: 'linear-gradient(90deg, #FF5252 0%, #FEE195 49.63%, #277252 100.75%)',
    },
    '& .MuiSlider-thumb': {
        height: 24,
        width: 24,
        backgroundColor: '#4e3bc9',
        outline: '2px solid #4e3bc9',
        outlineOffset: '4px',
        '&:focus,&:hover,&$active': {
            boxShadow: 'inherit',
        },
    },
});
const CustomSlider = ({ value, setValue, editable }) => {
    return (_jsx(Slider, { value: value, onChange: (event, v) => {
            setValue(v);
        }, min: 1, max: 3, disabled: editable }));
};
export default CustomSlider;
